var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59225 1.61342C5.53655 0.483693 7.92641 0.503439 9.85246 1.66514C11.7596 2.8505 12.9187 4.96602 12.908 7.24173C12.8635 9.50251 11.6206 11.6276 10.067 13.2705C9.17031 14.2229 8.1672 15.0652 7.07817 15.7799C6.96601 15.8448 6.84316 15.8882 6.71566 15.908C6.59296 15.9028 6.47346 15.8666 6.36795 15.8025C4.70533 14.7285 3.24671 13.3576 2.06225 11.7558C1.07113 10.4186 0.508049 8.80311 0.449463 7.12869L0.4539 6.8851C0.534824 4.69947 1.71739 2.70279 3.59225 1.61342ZM7.48612 5.26022C6.69572 4.92425 5.78444 5.10678 5.17777 5.72259C4.57111 6.33839 4.38872 7.26601 4.71578 8.0723C5.04284 8.8786 5.81482 9.40454 6.67128 9.40454C7.23236 9.40857 7.77171 9.18383 8.16916 8.78039C8.56661 8.37695 8.78913 7.82834 8.78715 7.2568C8.79013 6.38439 8.27652 5.59619 7.48612 5.26022Z",
    fill: "#0047AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.67874 18.5778C9.13612 18.5778 11.1282 18.1793 11.1282 17.6879C11.1282 17.1964 9.13612 16.798 6.67874 16.798C4.22135 16.798 2.22925 17.1964 2.22925 17.6879C2.22925 18.1793 4.22135 18.5778 6.67874 18.5778Z",
    fill: "#0047AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.872fce06a29adc478c914effa94a9999.svg";
export { ForwardRef as ReactComponent };